import * as React from 'react';
import { IntlProps } from 'ha/i18n';
import Link from 'ha/ui/next/Link';
import { City } from 'ha/services/apiV2/types/City';

interface OwnProps {
  localisedCountry: string;
  params: {
    localizedKind: string;
  };
  citiesNearby?: City[];
}

type Props = OwnProps & IntlProps;

const SearchCitiesNearby: React.SFC<Props> = ({
  citiesNearby = [],
  localisedCountry,
  intl: { T, urlResolver },
  params,
}) => (
  <div>
    <span>{T('Other cities in %s:', localisedCountry)} </span>
    {citiesNearby.map(({ cityName, cityCanonical, searchUrl }, index) => {
      const url = urlResolver.applyFilterToSearchUrl(
        searchUrl,
        params.localizedKind,
      );

      return (
        <React.Fragment key={cityCanonical}>
          <Link to={url} kind="mint-underline" title={cityName}>
            {cityName}
          </Link>
          {index + 1 < citiesNearby.length ? ', ' : null}
        </React.Fragment>
      );
    })}
  </div>
);

export default SearchCitiesNearby;
